import React from 'react';
import { CFormFeedback, CFormLabel, CInputGroup, CInputGroupText } from '@coreui/react-pro';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { Media } from '../Media';

const SimpleInputMaskGroup = ({
     name,
     label,
     className,
     classNameInput,
     placeholder,
     isRequired,
     value,
     error,
     handleChange,
     handlePaste,
     disabled,
     onBlur,
     mask,
     maskChar,
     image,
     append,
     prepend,
     divReplace,
}) => {
     return (
          <div className={`form-group ${className}`}>
               {label && (
                    <CFormLabel htmlFor={name}>
                         {label}
                         {isRequired && <span className="text-danger">*</span>}
                    </CFormLabel>
               )}
               <div className={`input-mask-group${isRequired && !!error ? ' is-invalid' : ''}`}>
                    <CInputGroup>
                         {prepend && <CInputGroupText className={`prepend-custom${disabled ? ' disabled' : ''}`}>Expires</CInputGroupText>}

                         {divReplace ? (
                              <div className="input-custom form-control div-replace" name="number">
                                   <p className="mb-0">**** **** **** </p>
                                   <p className="mb-0">{typeof value !== 'undefined' ? value : 4242}</p>
                              </div>
                         ) : (
                              <InputMask
                                   name={name}
                                   className={`${classNameInput} form-control${isRequired && !!error ? ' is-invalid' : ''}`}
                                   placeholder={placeholder}
                                   value={typeof value !== 'undefined' ? value : ''}
                                   disabled={disabled}
                                   mask={mask}
                                   maskChar={maskChar}
                                   onBlur={onBlur}
                                   onChange={handleChange}
                                   onPaste={handlePaste}
                              />
                         )}

                         {append && (
                              <CInputGroupText className={`append-custom${disabled ? ' disabled' : ''}`}>
                                   {image && <Media src={image} thumbnail width={30} height={20} />}
                              </CInputGroupText>
                         )}
                    </CInputGroup>
               </div>
               {isRequired && <CFormFeedback invalid>{error}</CFormFeedback>}
          </div>
     );
};

SimpleInputMaskGroup.propTypes = {
     name: PropTypes.string,
     label: PropTypes.string,
     isRequired: PropTypes.bool,
     value: PropTypes.any,
     error: PropTypes.string,
     disabled: PropTypes.bool,
     placeholder: PropTypes.string,
     mask: PropTypes.string,
     maskChar: PropTypes.string,
     image: PropTypes.string,
     onBlur: PropTypes.func,
     onPaste: PropTypes.func,
     handleChange: PropTypes.func,
     handlePaste: PropTypes.func,
};

SimpleInputMaskGroup.defaultProps = {
     value: '',
};

export default SimpleInputMaskGroup;
